import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Assistant } from '@app-libs/model'; 
import { ConfigurationClientService } from '../client/configuration-client.service';
import { ApiClient } from '../client/api-client';

@Injectable({
  providedIn: 'root',
})
export class AssistantsApiService extends ApiClient {
  // Example usage

  override get baseUrl(): string {
    return this.config.getBackendAPIUrl() + '/assistants';
  }

  constructor(config: ConfigurationClientService, http: HttpClient) {
    super(config, http);
  }

  // Fetch all assistants for workspace
  getAssistantsForWorkspace(): Observable<Assistant[]> {
    return this.http.get<Assistant[]>(`${this.baseUrl}/workspace`);
  }

  // Fetch the default assistant for workspace
  getDefaultAssistantForWorkspace(): Observable<Assistant> {
    return this.http.get<Assistant>(`${this.baseUrl}/workspace/default`);
  }

  // Fetch an assistant by ID
  getAssistantById(id: string): Observable<Assistant> {
    return this.http.get<Assistant>(`${this.baseUrl}/${id}`);
  }

  // Create a new assistant
  createAssistant(assistant: Partial<Assistant>): Observable<Assistant> {
    return this.http.post<Assistant>(`${this.baseUrl}`, assistant);
  }

  // Update an assistant
  updateAssistant(
    id: string,
    updates: Partial<Assistant>
  ): Observable<Assistant> {
    return this.http.put<Assistant>(`${this.baseUrl}/${id}`, updates);
  }

}
